import { render, staticRenderFns } from "./ProfileLinksForm.vue?vue&type=template&id=34c2916e&scoped=true&"
import script from "./ProfileLinksForm.vue?vue&type=script&lang=js&"
export * from "./ProfileLinksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c2916e",
  null
  
)

export default component.exports